export const config = {
  apiUrl: process.env.VUE_APP_API_URL,
  apiFileDownload:  process.env.VUE_APP_API_FILE_DOWNLOAD,
  apiFileUpload:  process.env.VUE_APP_API_FILE_UPLOAD,
  env: process.env.VUE_APP_ENV
}